const CAP_BITCOIN_ARQUITECTURA = {
  title: "Arquitectura de la Red Bitcoin",
  sections: [
    {
      heading: "Los Bloques",
      text: [
        "Un bloque es un conjunto de transacciones confirmadas junto con datos adicionales necesarios para mantener la integridad de la cadena. Cada bloque, excepto el Bloque Génesis, está enlazado criptográficamente con el bloque previo.",
        "Su función principal es registrar transacciones de manera permanente y ordenada dentro de la blockchain."
      ],
      bluepoint: [
        " **Hash previo:** código alfanumérico que enlaza con el bloque anterior.",
        " **Paquete de transacciones:** conjunto de transacciones incluidas, cuyo tamaño depende de varios factores como el peso y la comisión.",
        " **Hash del bloque:** otro código alfanumérico que servirá para enlazar con el siguiente bloque."
      ]
    },
    {
      heading: "Diagrama: estructura de un bloque en la cadena",
      image: {
        src: "https://raw.githubusercontent.com/AppsDevsLeon/ImagesBooks/refs/heads/main/imagesFundamentosBlockchain/Biucoinmaster/anatomia-de-un-bloque.webp",
        alt: "Diagrama de bloques de Bitcoin enlazados por hashes y transacciones",
        caption:
          "Cada bloque contiene: el hash del bloque anterior, el paquete de transacciones y un nuevo hash que lo conectará con el siguiente bloque de la cadena."
      },
      text: [
        "Te recomendamos tener este diagrama visible mientras lees el capítulo. La ilustración muestra cómo cada bloque incluye un enlace criptográfico al anterior, agrupa transacciones y genera un nuevo hash que servirá de referencia para el siguiente bloque."
      ]
    },
    {
      heading: "El Bloque en Progreso",
      text: [
        "Cuando un bloque aún no ha sido confirmado, los mineros compiten para encontrar un hash válido que cumpla con las reglas de dificultad de la red.",
        "Este proceso se basa en cálculos repetitivos y probabilísticos hasta que uno de los mineros encuentra una solución válida."
      ],
      bluepoint: [
        " **Cálculo del hash:** se realizan miles de millones de intentos por segundo.",
        " **Prueba de trabajo:** garantiza que solo quien demuestre trabajo computacional puede proponer un bloque.",
        " **Propagación a la red:** cuando un minero encuentra la solución, la transmite al resto de nodos."
      ]
    },
    {
      heading: "Los Mineros",
      text: [
        "Los mineros son equipos especializados que aportan poder computacional a la red. Su función es validar transacciones y buscar el hash correcto del siguiente bloque.",
        "Como incentivo, reciben recompensas en forma de nuevos bitcoins y comisiones por transacción."
      ],
      bluepoint: [
        " **Verificación:** revisan y ordenan transacciones.",
        " **Creación de bloques:** ensamblan el bloque en progreso.",
        " **Recompensa:** obtienen bitcoins recién emitidos más las comisiones pagadas por los usuarios."
      ]
    },
    {
      heading: "Los Nodos",
      text: [
        "Un nodo es un ordenador —o chip integrado— conectado a la red mediante un software que mantiene una copia completa o parcial de la blockchain.",
        "Cada vez que un bloque nuevo se confirma, se replica y valida en todos los nodos."
      ],
      bluepoint: [
        " **Replican la cadena:** almacenan una copia actualizada de la blockchain.",
        " **Verifican bloques:** aceptan o rechazan bloques según las reglas de consenso.",
        " **Distribuyen información:** comparten datos entre participantes.",
        " **Bitcoin Core:** es el software de nodo más utilizado en la red Bitcoin."
      ]
    },
    {
      heading: "Registro de propiedad vs envío de archivos",
      text: [
        "En Bitcoin no se envían archivos como en un protocolo P2P tradicional. Lo que ocurre realmente es un registro criptográfico que transfiere la propiedad de una cantidad específica de bitcoin.",
        "Esto significa que los bitcoins no existen como objetos, sino como entradas en un libro contable distribuido."
      ],
      bluepoint: [
        " **Bitcoin no es un archivo:** es una entrada en una base de datos pública.",
        " **Propiedad criptográfica:** el control depende de claves privadas.",
        " **Registro inmutable:** toda transferencia queda escrita permanentemente en la blockchain."
      ]
    },
    {
      heading: "Tipos de Redes en Bitcoin",
      text: [
        "Bitcoin opera sobre dos redes que funcionan por separado pero con estructuras similares.",
        "La primera es la red principal, donde operan bitcoins reales. La segunda es una red de pruebas sin valor monetario."
      ],
      bluepoint: [
        " **Mainnet:** red donde existen los bitcoin reales y las transacciones económicas efectivas.",
        " **Testnet (o Testnet3):** red de pruebas con monedas sin valor, ideal para experimentación, aprendizaje y desarrollo."
      ]
    }
  ]
};

export default CAP_BITCOIN_ARQUITECTURA;
